import { apiPath } from "../../config";


// const path = `/deal_room_list/${dealroom_id}/${resource_id}`;
export const AwsDealRoomDownloader = async (dealroom_id, resource_id, idToken) => {
    try {
        const options = {
          method: "GET",
          headers: {
            Authorization: `Bearer ${idToken}`,
            "Content-Type": "application/json",
          },
        };
        const path = `/deal_room_list/${dealroom_id}/${resource_id}`;
        const url = `${apiPath()}${path}`;
        const response = await fetch(url, options);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        return result.presigned_url;
  
      } catch (error) {
        console.error("Error fetching data:", error);
        return "error";
      }
}

export const autoDownloadInit = async (downloadableURL, filename) => {
    if (!downloadableURL) return;

    try {
        
        const link = document.createElement("a");
        link.href = downloadableURL;
        
        // Specify the filename for the downloaded file
        link.setAttribute("download", filename); // Replace "filename.pdf" with the desired filename and extension
        
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
            document.body.removeChild(link);
        }, 1000);
    } catch (error) {
        console.error("Error downloading file:", error);
    }
};